import React, { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import "../assets/css/styles.table.css"
import AxiosFetchData from '../pages/AxiosFetchData';
import ConfirmationButton from '../components/ConfirmationButton';
import Bindcomponent from '../utils/bindcomponent';


export const useRakApprovalHook = () =>{
     const [name, setName] = useState('');
      const [email, setEmail] = useState('');
      const [password, setPassword] = useState('');
      const [confirmPassword, setConfirmPassword] = useState('');
     
      const [confirmStatusOpen, setConfirmStatusOpen] = useState('');
      const [confirmDeleteOpen, setConfirmDeleteOpen] = useState('');
      const Navigate = useNavigate();
      const [rows, setRows] = useState([]);
     
      const [idStatus, setIdStatus] = useState('');
      const [roleList, setRoleList] = useState('');
      const [selectedRoles, setSelectedRoles] = useState('');
      const [message, setmessage] = useState('');
      const [tipe, settipe] = useState('');
      const [userName, setUserName] = useState('');
      const [userId, setUserId] = useState('');
      const [notes, setNotes] = useState('');
      const [openRetention, setOpenRetention] = React.useState(false);
      const [declinedId, setDeclinedId] = useState(0);
      const [roleAccess, setRoleAccess] = useState([]);
      const [approvalopen, setapprovalopen] = useState(false);
      const [projectId, setProjectId] = useState('');
      const [rowsDetail, setRowsDetail] = useState([]);

       useEffect(() => {
            fetchData(); 
        }, []);
      
        
        const fetchData = async () => {
          try {
            const response = await AxiosFetchData.get(`GetRakApproval`).refreshToken(Navigate,"approval");
            if(response){
                console.log(response.data)
                setRows(response.data); 
                setRoleAccess(response.roleaccess)
                // Add row numbers to the rows
                const rowsWithRowNumbers = response.data.map((row, index) => ({
                  ...row,
                  rowNumber: index + 1, 
                }));
               //  console.log(response)
              // alert(response.decode.name)
                setUserName(response.decode.name)
                setUserId(response.decode.userID)
                setRows(rowsWithRowNumbers);
      
            }
            
          } catch (error) {
            setmessage(error.message);
            settipe('errorlog')
          }
        };
      
        async function handleStatus(id,status){
          try{
              var data = {
                  decline_reason : notes
              }
              const response = await AxiosFetchData.update(`ChangeApprovalStatus/${id}/${status}/${userName}/${userId}`, data).refreshToken(Navigate,"approval");
              setmessage(response.data);
              await fetchData();
              setOpenRetention(false)
             
          }catch(error){
              setmessage(error.message);
              settipe('errorlog')
          }
         
        }
       
      const columns = [
        { field: 'rowNumber', headerName: 'No.', width: 80 },
        { field: 'request_date', headerName: 'Request Date', width: 150 },
        { field: 'request_by_name', headerName: 'Request By', width: 150 },
        { field: 'nama_project', headerName: 'Project Name', width: 150 },
        { field: 'type', headerName: 'Type', width: 150 },
        { field: 'status', headerName: 'Status', width: 150 },
        {
          field: 'actions',
          headerName: 'Actions',
          width: 250,
          renderCell: (params) => (
            <>
            <Bindcomponent component='ConfirmationButton' classname='btn btn-primary mr-2' text="Do you want approved this data?" type="button"  disabled={roleAccess.UPDATE == true ? (params.row.lastId == 'last' ? false :true) : !roleAccess.UPDATE} onClick={async () => await handleStatus(params.row.id, 1)}>Approved</Bindcomponent>
             
             <Bindcomponent component='ConfirmationButton' classname='btn btn-danger mr-2' text="Do you want declined this data?" type="button" disabled={roleAccess.DELETE == true ? (params.row.lastId == 'last' ? false :true) : !roleAccess.DELETE}  onClick={async () => await handleDecline(params.row.id)}>Declined</Bindcomponent>
          
          <button
                                       onClick={() =>
                                        {
                                          setapprovalopen(true);
                                          setProjectId(params.row.project_id)
                                          setRowsDetail(params.row)
                                        } } // Pass the project ID to the edit function
                                      className="btn btn-info"
                                     
                                    >
                                       Detail
                                     </button>
          
            </>
            
          ),
      },
      
      
      
      ];
      
      const [filterModel, setFilterModel] = React.useState({
        items: [],
        quickFilterExcludeHiddenColumns: true,
        quickFilterValues: [''],
      });
      
      const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});
      // end table
      
     
      async function AddStatus(e){
        e.preventDefault(); 
          if(idStatus){
              
            var data = {
              id: idStatus,
              name : name,
              email : email,
              password :  password,
              confirmpassword :  confirmPassword,
              role : selectedRoles
            }
            var response = await AxiosFetchData.post(`UpdateUser`, data).refreshToken(Navigate,"approval")
            if(response){
              setConfirmStatusOpen(false);
              setmessage(response.data.message);
            }
          }else{
            var data = {
              name : name,
              email : email,
              password :  password,
              confirmpassword :  confirmPassword,
              role : selectedRoles
            }
           
            var response = await AxiosFetchData.post(`Register`, data).refreshToken(Navigate,"approval")
      
            if(response){
             // console.log(response)
              setConfirmStatusOpen(false);
              setmessage(response.data.message);
            }
          }
          await fetchData();
      }
      
      const handleDelete = async (data) => {
        setConfirmDeleteOpen(true)
        setName(data.name);
        setIdStatus(data.id)
         
      };
      
      const handleDeleteStatus = async (data) => {
        
          try {
            const response = await AxiosFetchData.delete(`DeleteUser/${data}`).refreshToken(Navigate,"approval");
             if(response){
              setRows((prevRows) => prevRows.filter((row) => row.id !== data));
            }
            setmessage(response.data);
            //setConfirmDeleteOpen(false);
          } catch (error) {
            setmessage(error.message);
            settipe('errorlog')
          }
        
      };
      
      async function handleRetentionClose(event, reason){
              if(reason !== "backdropClick"){
              setOpenRetention(false);
            }
           
        }
      
        async function handleDecline(id){
          setDeclinedId(id)
          setNotes('')
          setOpenRetention(true);
        }
      
        
        async function handleSaveDecline(e){
          e.preventDefault();
           await handleStatus(declinedId, 3);
        }

        return {message,setmessage,tipe,settipe,columns,rows,filterModel,setFilterModel,columnVisibilityModel,setColumnVisibilityModel,confirmStatusOpen,setConfirmStatusOpen,AddStatus,
                name,setName,email,setEmail,idStatus,password,setPassword,confirmPassword,setConfirmPassword,roleList,setSelectedRoles,selectedRoles,confirmDeleteOpen,setConfirmDeleteOpen,
                openRetention,handleRetentionClose,handleSaveDecline,notes,setNotes,approvalopen,setapprovalopen,rowsDetail,projectId,handleDeleteStatus
        }
}